import { Tooltip } from '@mui/material';
import { WarningAmberOutlined as WarningIcon } from '@mui/icons-material';
import styled from '@emotion/styled';
import { FormattedMessage } from 'react-intl';

const StyledWarningIcon = styled(WarningIcon)({
  marginTop: -4,
  marginBottom: -4,
  marginLeft: 8,
  width: 18,
  height: 18,
});

type CannotPickItemWarningProps = {
  variant: 'file' | 'folder';
};

const CannotPickItemWarning = ({ variant }: CannotPickItemWarningProps) => (
  <Tooltip
    title={
      <FormattedMessage
        id={`portfolio.challenge.files.add.select.onedrive.file_picker.filesystem.cannot_pick_item_warning.${variant}`}
      />
    }
  >
    <StyledWarningIcon />
  </Tooltip>
);

export default CannotPickItemWarning;
